
    <div [ngClass]="{'radio-inline': inline, 'radio': !inline}" *ngFor="let item of options"><label><input type="radio" [name]="name" [value]="valueParser(item)" [checked]="isChecked(item)" [disabled]="isDisabled(item)" (change)="onRadioChange(item)">{{formatter(item)}}</label></div>
  